import React from 'react';

import './ZoomableContent.scss';

const ZoomableContent = ({ children }) => (
    <div className="zoomable">{children}</div>
);

export default ZoomableContent;
